/*@ngInject*/
const OrganizationRepository = function ($q, baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    const closeOrganizationPersistentConnectionPromises = {};

    this.getOrganizationsByFilterUriAndOrganizationType = function (filterUri, organizationType, requestParams) {
        const url = '/rest/Organization/filter',
            config = {
                params: {
                    filterUri: filterUri,
                    organizationType: organizationType,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

        return this.get(url, config);
    };

    this.loadOrganizationById = function (organizationId) {
        const url = `/rest/Organization/${organizationId}`,
            config = {
                params: {
                    registrationIdentifier: `/Organization/${organizationId}`
                }
            },
            closeOrganizationPersistentConnectionPromise = closeOrganizationPersistentConnectionPromises[organizationId] || $q.when();

        return closeOrganizationPersistentConnectionPromise.then(() => {
            return this.get(url, config);
        });
    };

    this.closeOrganizationPersistentConnection = function (organizationId) {
        const url = `/rest/Organization/${organizationId}/List`,
            config = {
                params: {
                    registrationIdentifier: `/Organization/${organizationId}`
                }
            },
            promise = this.delete(url, config);

        closeOrganizationPersistentConnectionPromises[organizationId] = promise;

        return promise;
    };

    this.upgradeForms = function (organizationId) {
        const url = `/rest/Organization/${organizationId}/upgradeForms`;
        return this.post(url);
    };

    this.getForms = function (organizationId) {
        const url = `/rest/Organization/${organizationId}/formSummaries`;
        return this.get(url);
    };

    this.backupOrganizations = function () {
        const url = '/database/DatabaseDownloadServlet',
            config = {
                params: {
                    sectionName: databaseDownloadSectionName.ORGANIZATIONS
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

};

angular.module('ums.configuration')
    .service('organizationRepository', OrganizationRepository);
